import { AxisChartAPI } from '../axis-chart/axis-chart-api.js';
class BarChartAPI extends AxisChartAPI {
    /**
     * Returns the gap between the bar categories.
     */
    getBarCategoryGap() {
        return this.state.barCategoryGap;
    }
    /**
     * Sets the gap between the bar categories.
     *
     * @param barCategoryGap - The gap value.
     */
    setBarCategoryGap(barCategoryGap) {
        this.setState({ barCategoryGap });
    }
    /**
     * Returns the gap between the bars.
     */
    getBarGap() {
        return this.state.barGap;
    }
    /**
     * Sets the gap between the bar.
     *
     * @param barGap - The gap value.
     */
    setBarGap(barGap) {
        this.setState({ barGap });
    }
    /**
     * Returns the chart bars.
     */
    getBars() {
        return this.state.bars;
    }
    /**
     * Sets the chart bars.
     *
     * @param bars - The chart bars.
     */
    setBars(bars) {
        this.setState({ bars });
    }
}
export { BarChartAPI, };
//# sourceMappingURL=bar-chart-api.js.map